import React, { useState } from "react";
import "./ParticipantProfilePictureUpload.css";
import handlePictureUpload from "./handlePictureUpload";

interface ParticipantProfilePictureUploadProps {
  selectedFundraiserRoleIdInt: number;
  setProfilePictureUrl: (url: string | null) => void;
}

const ParticipantProfilePictureUpload: React.FC<
  ParticipantProfilePictureUploadProps
> = ({ selectedFundraiserRoleIdInt, setProfilePictureUrl }) => {
  const [formError, setFormError] = useState<string>("");

  return (
    <div className="participant-join-form-file-upload-container">
      <label className="participant-join-form-file-upload">
        <input
          type="file"
          onChange={(event) =>
            handlePictureUpload(
              event,
              setProfilePictureUrl,
              setFormError,
              selectedFundraiserRoleIdInt
            )
          }
          disabled={selectedFundraiserRoleIdInt === 0}
        />
        Choose Profile Picture
      </label>
      {formError && <p className="error-message">{formError}</p>}
    </div>
  );
};

export default ParticipantProfilePictureUpload;
